var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('checkbox-grid-dropdown',{attrs:{"label":_vm.label,"options":_vm.filteredOptions,"allText":"All","action-groups":_vm.actionGroups,"clearable":"","select-all":""},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }